import * as React from "react";

export const RemapIcon: React.SFC = ({}) => (
  <svg
    width="18px"
    height="20px"
    viewBox="0 0 18 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.02659911,4.6598365 L14.1595947,4.6598365 L14.1595947,6.60205967 C14.1595947,7.09032806 14.7067764,7.32903705 15.0208993,6.98182397 L17.8480051,3.95455993 C18.050665,3.73755176 18.050665,3.40118909 17.8480051,3.18418091 L15.0208993,0.156916869 C14.7067764,-0.179445802 14.1595947,0.0592631903 14.1595947,0.547531584 L14.1595947,2.48975475 L3.01329956,2.48975475 C2.4559848,2.48975475 2,2.97802314 2,3.57479563 L2,7.91495913 C2,8.51173161 2.4559848,9 3.01329956,9 C3.57061431,9 4.02659911,8.51173161 4.02659911,7.91495913 L4.02659911,4.6598365 Z M13.9734009,15.3401635 L3.84040532,15.3401635 L3.84040532,13.3979403 C3.84040532,12.9096719 3.29322356,12.6709629 2.9791007,13.018176 L0.151994934,16.0454401 C-0.0506649778,16.2624482 -0.0506649778,16.5988109 0.151994934,16.8158191 L2.9791007,19.8430831 C3.29322356,20.1794458 3.84040532,19.9407368 3.84040532,19.4524684 L3.84040532,17.5102452 L14.9867004,17.5102452 C15.5440152,17.5102452 16,17.0219769 16,16.4252044 L16,12.0850409 C16,11.4882684 15.5440152,11 14.9867004,11 C14.4293857,11 13.9734009,11.4882684 13.9734009,12.0850409 L13.9734009,15.3401635 Z"
      id="path-map"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/RemapIcon.tsx